<template>
    <div class="panel">
        <div class="panel-body">
            <div class="row">
                <form class="form-horizontal" style="padding-top:10px" id="bs_form">
                    <!--培训项目-->
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="col-sm-3 control-label">培训项目</label>
                            <div class="col-sm-9">
								<BootstrapCombobox :data="pcList" text-field="mc" value-field="id" v-model="query.pcId" placeholder="-培训项目筛选-"></BootstrapCombobox>
                            </div>
                        </div>
                    </div>
                    <!--课程-->
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="col-sm-3 control-label">课程</label>
                            <div class="col-sm-9">
                                <BootstrapCombobox :data="kcList" value-field="id" text-field="kcmc" v-model="query.kcId" :format-option="showKcOption"></BootstrapCombobox>
                            </div>
                        </div>
                    </div>
                    <!--学员单位-->
                    <div class="col-sm-6" v-if="js == 'YWGLY' || js == 'ZYPX_YWGLY'">
                        <div class="form-group">
                            <label class="col-sm-3 control-label">学员单位</label>
                            <div class="col-sm-9">
								<BootstrapCombobox :data="qyList" value-field="id" text-field="jgmc" v-model="query.qyId" placeholder="-学员单位筛选-"></BootstrapCombobox>
                            </div>
                        </div>
                    </div>
                    <!--成绩项-->
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="col-sm-3 control-label">成绩项</label>
                            <div class="col-sm-9">
                                <select name="cjx" v-model="query.cjx" class="form-control"
                                        v-validate="{required:true,max:50}" data-vv-as="成绩项">
                                    <option value="">-成绩项筛选-</option>
                                    <option v-for="item in cjxList" :key="item.value" :value="item.value">
                                        {{item.text}}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <!--按钮-->
					<div :class="(js == 'YWGLY' || js == 'ZYPX_YWGLY') == true ? 'col-sm-12' : 'col-sm-6'">
                        <div class="pull-right">
                            <button @click="total()" type="button" class="btn btn-primary btn-sm"
                                    style="margin-right:3px"><i class="fa fa-search-plus" aria-hidden="true"></i>统计
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <div class="row">
                <div class="col-sm-12" style="padding-top: 10px">
                    <BootstrapTable style="font-size: 14px;"
                                    ref="table"
                                    v-once
                                    :columns="columns"
                                    :options="{
										classes:'table table-hover',
                                    	undefinedText:'',
                                        showColumns: false,
                                        sidePagination:'server',
                                        pagination:true,
                                        pageNumber:1,
                                        pageSize:10,
                                        pageList:[10,50,100,500],
                                        paginationPreText:'上一页',
                                        paginationNextText:'下一页',
                                        showExtendedPagination:true,
                                        paginationLoop:false
                                    }"
                                    @onPostBody="vueFormatterPostBody"
                                    @onPageChange="pageChange"
									@onClickRow="clickRow"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    /**
     * 培训成绩统计
     */
    import tableMixin from '@/mixins/table.js';  //表格
    export default {
        mixins: [tableMixin],
        name: "TrainingScoreTongJiList",
        data: function () {
            return {
            	js: this.$store.state.user.js,
                kcList: [],
                pcList: [],
                qyList: [],
                cjxList: [],
                query: {
                	cjx:'',
                    pcId:'',
                    kcId:'',
                    qyId:'',
                },
                columns: [
                    {
                        field: 'state',
                        checkbox: true
                    },
                    {
                        title: '序号',
                        field: 'id',
                        align: 'center',
                        formatter: (value, row, index) => {
                            var options = this.$refs.table.getOptions();
                            return options.pageSize * (options.pageNumber - 1) + index + 1;
                        }
                    },
                    {
                        field: 'xmbh',
                        title: '培训项目编号'
                    },
                    {
                        field: 'pcmc',
                        title: '培训项目名称'
                    },
                    {
                        field: 'dwmc',
                        title: '学员单位',
                        formatter: (value, row) => {
                            if (row.dwdm && row.dwmc) {
                                return row.dwdm + '-' + row.dwmc;
                            }
                            return '';
                        }

                    },
                    {
                        field: 'kcmc',
                        title: '课程'
                    },
                    {
                        field: 'kcxz',
                        title: '课程性质',
                        formatter: (value) => {
                            return value == '0' ? '理论课' : value == '1' ? '实训课' : '毕业考核课';
                        }
                    },
                    {
                        field: 'a',
                        title: '60分以下人数'
                    },
                    {
                        field: 'b',
                        title: '60至79人数'
                    },
                    {
                        field: 'c',
                        title: '80至99人数'
                    },
                    {
                        field: 'd',
                        title: '100分人数'
                    },
                ]
            }
        },
		mounted(){
			this.query = Object.assign(this.query,{current:1,size:10},this.$route.query);
			this.load();
		},
		beforeRouteUpdate(to, from, next){
			this.query = Object.assign(this.query,{current:1,size:10},to.query);
			this.load();
			next();
		},
        created: function () {
        	this.cjxList = [{value: 'ZCJ', text: '总成绩'}, {value: 'XXCJ', text: '学习成绩'}, {value: 'PSZYCJ', text: '平时作业成绩'}, {value: 'ZHCYCJ', text: '综合测验成绩'}];
            this.$store.commit('setBreadcrumb', [{name: '职业培训'}, {name: '在线培训'}, {name: '培训成绩管理'}, {name: '培训成绩统计'}]);
			this.getpcList();
            this.getqyList();
        },
        watch: {  //课程列表联动
            "query.pcId": function (value) {
				this.query.kcId = '';
                if (value) {
                    this.$http.post("/htgl/biz/zypx/cjtj/hqByKc", {xmId: value}).then(res => {
                        this.kcList = res.data;
                    });
                }
                else {
                    this.kcList = [];
                }
            }
        },
        methods: {
            showKcOption(item){
                return item.kcdm+'-'+item.kcmc;
            },
        	total: function () {
    		  if(this.query.pcId){
	              //将数据表格的页码以及每一页展示的数据重置为1，10
	              this.query = Object.assign(this.query,{current:1,size:10},{_t:new Date().getTime()});
	              this.$router.push({name:this.$route.name,query:this.query});
              }else{
                  this.$error('请选择培训项目进行统计',()=>{})
              }
             
            },
        	 //培训项目列表
            getpcList: function () {
                this.$http.post('/htgl/biz/zypx/cjtj/hqByPc').then(res => {
                    this.pcList = res.data;
                });
            },
            //获取学员单位列表
            getqyList: function () {
                this.$http.post('/htgl/biz/zypx/cjtj/hqByQy').then(res => {
                    if (res.data) {
                        this.qyList = res.data;
                    }
                });
            },

             //返回表格数据
            load: function (pageNumber, pageSize) {
               this.query.current = pageNumber || this.query.current;
               this.query.size = pageSize || this.query.size;
          	   if(!this.query.cjx){
          		   this.query.cjx = 'ZCJ';
          	   }
               this.$http.post('/htgl/biz/zypx/cjtj/fycx', this.query).then(res => {
                   let data = res.data;
                   let result = {
                       total: data.total,
                       rows: data.records
                   };
                   // table加载返回的数据
                  this.$refs.table.load(result);
				  this.$refs.table.refreshOptions({pageNumber:parseInt(this.query.current),
						pageSize:parseInt(this.query.size)});
               });
            },
			pageChange: function (pageNumber, pageSize) {
			 let query = Object.assign(this.query,{current:pageNumber,size:pageSize},{_t:new Date().getTime()});
			 this.$router.push({name:this.$route.name,query:query});
			}
        }

    }
</script>
<style scoped>

</style>
